import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from '@core/services';
import { IUser, UserType } from '@core/interfaces';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ContentItem } from '@app/core/interfaces/contentItem';
import { BusinessRoutePaths } from '@core/configs/route-paths';

@Component({
    selector: 'header-menu',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']

})
export class HeaderComponent implements OnInit {
    public dropdownItems: Array<ContentItem> = [
        { Name: "Create for user", Link: "sign-up" },
        { Name: "Create for business", Link: "sign-up-business" }
    ]


    public profileIconDropDown: Array<ContentItem> = [
        { Name: "Appointments", Link: "Appointments" },
        { Name: "Account settings", Link: "settings" },
        { Name: "Sign out", Link: "sign-out" }
    ];

    constructor(
      public authService: AuthenticationService,
      private router: Router,
      private toastService: ToastrService,
      private translate: TranslateService,
    ) {
        this.authService.currentUser.subscribe(x => {
            this.currentUser = x;
            this.isLoggedIn = !!this.currentUser;
        }
        );
        this.checkCreateSignUpButtonsVisibility(this.router.url);
        this.router.events
          .subscribe((event) => {
            if (event instanceof NavigationEnd) {
                this.currentRoute = event.url;
                this.checkCreateSignUpButtonsVisibility(event.url);
            }
        });
    }
    public showDorpdown: boolean = false;
    public showProfileDropdown: boolean = false;

    ngOnInit(): void {
        this.showDorpdown = false;
    }

    public currentUser: IUser;
    public isLoggedIn: boolean = false;
    public isBusiness: boolean = true;
    public currentRoute: string;
    public showCreateSignUpButtons: boolean = true;
    isExpanded = false;

    get userActiveType() {
      return this.authService.currentUserActiveType;
    }

    checkCreateSignUpButtonsVisibility(url): void {
      this.showCreateSignUpButtons = !(
        url.indexOf('sign-in') != -1 ||
        url.indexOf('info-confirm-email') != -1 ||
        url.indexOf('sign-up') != -1
      );
    }

  collapse() {
        this.isExpanded = false;
    }

    toggle() {
        this.isExpanded = !this.isExpanded;
    }

    logout() {
        this.authService.logout();
    }

    public toggleDropdown(): void {
        this.showDorpdown = !this.showDorpdown;
    }

    public closeDropdown(): void {
        this.showDorpdown = false;
        this.showProfileDropdown = false;
    }

   public toggleProfileOptions() {
        this.showProfileDropdown = !this.showProfileDropdown;
    }

  switchAccount() {
      const newActiveType = this.userActiveType === UserType.Business ? UserType.Customer : UserType.Business;
    this.authService.switchAccount({userType : newActiveType} )
      .subscribe({
        next: () => {
          localStorage.setItem('userActiveType', newActiveType.toString());
          this.router.navigate([newActiveType === UserType.Business ? BusinessRoutePaths.root : '/']);
        },
        error: err => {
          this.toastService.error(err, this.translate.instant('general.error_message'));
        }
      })
  }
}
